import DateFormat from "./date-format";

export default class BookingLink {

	constructor() {

		const body = document.querySelector('body');

		if (!body.dataset.checkInLeadtime || !body.dataset.checkOutLeadtime) {
			return;
		}

		const checkIn = DateFormat.addDays(new Date(), Number.parseInt(body.dataset.checkInLeadtime));
		const checkOut = DateFormat.addDays(new Date(), Number.parseInt(body.dataset.checkOutLeadtime));

		document.querySelectorAll('a[href*="book-directonline"]').forEach(bookingLink => {
			const url = new URL(bookingLink.href);
			if (url.searchParams.has('checkInDate') && url.searchParams.has('checkOutDate')) {
				return;
			}
			url.searchParams.set('checkInDate', DateFormat.format(checkIn, DateFormat.ISO_8601));
			url.searchParams.set('checkOutDate', DateFormat.format(checkOut, DateFormat.ISO_8601));
			bookingLink.href = url.toString();
			bookingLink.target = '_blank';
		});
	}
}
